import {
  React,
  Component
} from 'imports/CommonImports';

import {
  Dialog,
  CircularProgress
} from 'material-ui';

export default class AlertDialog extends Component {

  render() {
    return (
      <div>
        <Dialog
          modal={false}
          open={true}
        >
        {this.props.message}
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>

        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/design/LoadingDialog.js